import type { ConfigProviderProps } from 'antd'
import ja_JP from 'antd/locale/ja_JP'

export const config: ConfigProviderProps = {
  theme: {
    token: {
      colorError: '#f94d42',
      colorWarning: '#f9d342',
      fontSizeHeading1: 25,
      fontSizeHeading2: 20,
      fontSizeHeading3: 18,
      fontSizeHeading4: 15,
      fontSizeXL: 18,
      fontSizeHeading5: 14,
      lineHeightHeading1: 1.3,
      lineHeightHeading2: 1.3,
      lineHeightHeading3: 1.3,
      lineHeightHeading4: 1.3,
      lineHeightHeading5: 1.3,
      lineHeight: 1.5,
      lineHeightSM: 1.5,
      borderRadiusSM: 6,
      borderRadiusXS: 3,
      wireframe: false,
      colorPrimary: '#142238',
      colorInfo: '#142238',
      colorPrimaryHover: '#68797e',
      colorPrimaryBg: '#142238',
      colorPrimaryBgHover: '#68707E',
      colorPrimaryBorder: '#f2f2f2',
      colorPrimaryBorderHover: '#F9D342',
      colorPrimaryTextHover: '#68707',
      colorPrimaryActive: '#142238',
      colorPrimaryTextActive: '#ffffff',
    },
    components: {
      Input: {
        colorPrimary: '#f9D342',
        colorWarningOutline: 'rgba(255, 238, 5, 0.06)',
        controlItemBgActive: '#E5E8F0',
        colorBgContainer: '#F2F2F6',
        colorBorder: '#ffffff',
        colorTextTertiary: 'rgba(0, 0, 0, 0.45)',
        colorFillSecondary: '#ffffff',
        lineWidth: 1.5,
        fontSizeIcon: 12,
        controlHeightXS: 16,
        controlHeightSM: 32,
        controlHeight: 40,
        controlOutline: 'rgba(255, 238, 5, 0.06)',
        colorFillAlter: '#F5F5F5',
        controlOutlineWidth: 2,
        colorPrimaryHover: 'rgb(249, 211, 66)',
      },
      Button: {
        defaultBorderColor: '#142238',
        lineWidth: 2,
        controlOutlineWidth: 0,
        lineHeight: 1,
        fontWeight: 600,
        contentFontSizeLG: 16,
        contentFontSize: 13,
        contentFontSizeSM: 11,
        paddingInlineLG: 32,
        paddingInline: 24,
        paddingInlineSM: 16,
        onlyIconSize: 13,
        onlyIconSizeLG: 15,
        onlyIconSizeSM: 11,
        controlHeightLG: 44,
        controlHeight: 36,
        controlHeightSM: 30,
        textHoverBg: 'rgba(0, 0, 0, 0)',
        colorPrimaryHover: 'rgba(20, 34, 56, 0.6)',
        colorLinkHover: 'rgba(20, 34, 56, 0.6)',
        marginXS: 10,
      },
      Radio: {
        colorPrimaryActive: '#142238',
        colorPrimary: '#F9D342',
      },
      Menu: {
        controlItemBgActive: 'rgb(229, 232, 240)',
        itemBorderRadius: 3,
        subMenuItemBorderRadius: 3,
      },
      Checkbox: {
        borderRadiusSM: 4,
        colorBorder: '#48576A',
        colorBgContainer: '#F2F2F6',
        colorPrimary: '#F9D342',
        colorPrimaryHover: '#FDDD4C',
      },
      Pagination: {
        colorPrimary: '#ffffff',
        colorBgTextActive: '#ffffff',
        colorBgContainer: '#142238',
        colorText: 'rgba(0, 0, 0, 0.88)',
        colorPrimaryHover: '#68707E',
        colorBgTextHover: '#ffffff',
      },
      Select: {
        colorPrimary: '#f9D342',
        colorWarningOutline: 'rgba(255, 238, 5, 0.06)',
        controlItemBgActive: '#E5E8F0',
        colorBgContainer: '#F2F2F6',
        colorBorder: '#ffffff',
        colorTextTertiary: 'rgba(0, 0, 0, 0.45)',
        colorFillSecondary: '#ffffff',
        colorPrimaryHover: '#f9d342',
        lineWidth: 1.5,
        fontSizeIcon: 12,
        controlHeightXS: 16,
        controlHeightSM: 32,
        controlHeight: 40,
        controlOutline: 'rgba(255, 238, 5, 0.06)',
      },
      Transfer: {
        controlItemBgActive: '#E5E8F0',
      },
      Tag: {
        lineHeightSM: 2,
        fontSizeSM: 11,
        fontSizeIcon: 11,
        borderRadiusSM: 5,
      },
      Calendar: {
        controlItemBgActive: 'rgb(195, 209, 233)',
      },
      DatePicker: {
        colorPrimary: '#f9D342',
        colorWarningOutline: 'rgba(255, 238, 5, 0.06)',
        controlItemBgActive: '#E5E8F0',
        colorBgContainer: '#F2F2F6',
        colorBorder: '#ffffff',
        colorTextTertiary: 'rgba(0, 0, 0, 0.45)',
        colorFillSecondary: '#ffffff',
        lineWidth: 1.5,
        fontSizeIcon: 12,
        controlHeightXS: 16,
        controlHeightSM: 32,
        controlHeight: 40,
        controlOutline: 'rgba(255, 238, 5, 0.06)',
        colorFillAlter: '#F5F5F5',
        controlOutlineWidth: 2,
        colorPrimaryHover: 'rgb(249, 211, 66)',
      },
      Form: {
        itemMarginBottom: 40,
      },
    },
  },
  locale: ja_JP,
}
